module.exports = __webpack_public_path__ + "static/media/510.416565f1.webp";